import { getWorkflowData } from '../../../../legacy/legacy';

const workflow = getWorkflowData();

const createPresetUrl = (id: string, type: WFPresetType) => {
	switch (type) {
		case 'campaign':
			return `/workflow/campaign/add/?preset=${id}`;

		case 'job':
			if (workflow.campaignId) {
				return `/workflow/job/add/${workflow.campaignId}/?preset=${id}`;
			}

			return `/workflow/job/add/?preset=${id}`;

		default:
			return '';
	}
};

export const createNewPreset = (preset: WorkflowVisiblePresets) => {
	const capitalizedType = `${preset.type[0].toUpperCase()}${preset.type.slice(1)}`;

	return {
		id: preset.id,
		label: preset.name,
		url: createPresetUrl(preset.id, preset.type),
		dataInit: `${capitalizedType}.new`,
	};
};
